import { render, staticRenderFns } from "./MapItemShow.vue?vue&type=template&id=63b9832d"
import script from "./MapItemShow.vue?vue&type=script&lang=js"
export * from "./MapItemShow.vue?vue&type=script&lang=js"
import style0 from "./MapItemShow.vue?vue&type=style&index=0&id=63b9832d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports